export class UrlHelper {
    static GetAbsoluteUrl(url: string): string {
        let absoluteUrl = url.split('?')[0];
        if (absoluteUrl[absoluteUrl.length - 1] == '/') {
            absoluteUrl = absoluteUrl.substr(0, absoluteUrl.length - 1);
        }

        return absoluteUrl;
    }
}
